import * as d3 from "d3";
export const defaultTickFormatSpecifier = "squiggle-default";
function isCustomFormat(specifier) {
    return specifier === "squiggle-default" || specifier === undefined;
}
function squiggleDefaultFormat() {
    const locale = d3.formatLocale({
        decimal: ".",
        thousands: ",",
        grouping: [3],
        currency: ["$", ""],
        minus: "-",
    });
    const siFormat = locale.format(".9~s");
    const expFormat = locale.format(".9~e");
    const fixedFormat = locale.format(".9~f");
    return (d) => {
        const abs = Math.abs(Number(d));
        if (abs === 0) {
            return fixedFormat(d);
        }
        else if (abs < 0.00001) {
            return expFormat(d);
        }
        else if (abs < 1e6) {
            return fixedFormat(d);
        }
        else if (abs < 1e9) {
            return siFormat(d);
        }
        else if (abs < 1e12) {
            return fixedFormat(Number(d) / 1e9) + "B";
        }
        else if (abs < 1e15) {
            return siFormat(d);
        }
        else {
            return expFormat(d);
        }
    };
}
function tickFormatWithCustom(start, stop, count, specifier) {
    if (isCustomFormat(specifier)) {
        return squiggleDefaultFormat();
    }
    return d3.tickFormat(start, stop, count, specifier);
}
function patchLinearishTickFormat(scale) {
    scale.tickFormat = (count, specifier) => {
        const d = scale.domain();
        return tickFormatWithCustom(d[0], d[d.length - 1], count ?? 10, specifier);
    };
    return scale;
}
function patchSymlogTickFormat(scale) {
    return patchLinearishTickFormat(scale);
}
function patchLogarithmicTickFormat(scale) {
    const logScaleTickFormat = scale.tickFormat;
    scale.tickFormat = (count, specifier) => {
        return logScaleTickFormat(count, isCustomFormat(specifier)
            ?
                squiggleDefaultFormat()
            : specifier);
    };
    return scale;
}
export function scaleLinear() {
    return patchLinearishTickFormat(d3.scaleLinear());
}
export function scaleSymlog() {
    return patchSymlogTickFormat(d3.scaleSymlog());
}
export function scalePow() {
    return patchLinearishTickFormat(d3.scalePow());
}
export function scaleLog() {
    return patchLogarithmicTickFormat(d3.scaleLog());
}
//# sourceMappingURL=patchedScales.js.map